<template>
  <div>
    <build-bag-view :search.sync="searchedDisc" :discs="GetNotDiscraft" :disabled="disabled"/>
    <v-container>
        <disc-list-view :search="searchedDisc" :discCraftDiscs="GetDiscraftDiscs" />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import BuildBagView from "../components/BuildBag/BuildBagView.vue";
import DiscListView from "../components/DiscList/DiscListView.vue";
import Http from "../utils/Http/Http";
import {mapActions, mapGetters} from "vuex";
export default {
  name: 'Home',
  components: {
    BuildBagView,
    DiscListView,
  },

  data: () => ({
    searchedDisc: {},
    disabled: false,
  }),

  methods:{
    ...mapActions(["SetDiscsInitial"]),
  },

  computed: {
        ...mapGetters(["GetNotDiscraft", "GetAllDiscs", "GetDiscraftDiscs"]),
  },

  async mounted(){
    this.disabled = true;
    let http = new Http();
    let data = await http.GetAsync("https://v2-api.sheety.co/7857c44d72f917a31eba62b8fa4163c3/buildMyBag/discs");
    if(data != null && data != undefined){
      this.SetDiscsInitial(data.discs);
    } else {
      this.SetDiscsInitial([]);
    }
    this.disabled = false;
  }
}
</script>
